import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

// -> Component import
import App from './App';

// -> redux import
import { Provider } from 'react-redux';
import { store } from './state/stores/rootStore';

// -> SASS import
import './assets/sass/app.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        <Provider store={store}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </Provider>
    </React.StrictMode>,
);
